const TOB_SELECTOR = '[data-page-tob-courses]';
const TOB_SELECT_FILTER = '[data-select-filter]';

export const setupTobCourses = () => {
	const tobCourseEl = document.querySelector(TOB_SELECTOR);
    if(tobCourseEl){
        filterByState(tobCourseEl);
    }
};

const filterByState = (tobCourseEl) => {
	const selectFilter = document.querySelector(TOB_SELECT_FILTER);
	const allStates = document.querySelectorAll('.state-item');
	selectFilter.addEventListener('change', function() {
        if(this.value==0){
            allStates.forEach(function(el) {
                el.style.display = 'block';
             });
        } else{
            allStates.forEach(function(el) {
                el.style.display = 'none';
             });
            document.getElementById(this.value).style.display = 'block';
            // window.scrollTo({ top: 0, behavior: 'smooth' });
        }
	});
};
